"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CruiseModal = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _reactI18next = require("react-i18next");
var _Train = _interopRequireDefault(require("@material-ui/icons/Train"));
var _Place = _interopRequireDefault(require("@material-ui/icons/Place"));
var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));
var _Header = _interopRequireDefault(require("../components/Header"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));
var _excluded = ["icon", "content"];
var CruiseModal = exports.CruiseModal = function CruiseModal(_ref) {
  var title = _ref.title,
    departure = _ref.departure,
    returns = _ref.returns,
    vendor = _ref.vendor,
    reservationCode = _ref.reservationCode,
    address = _ref.address,
    phoneNumber = _ref.phoneNumber,
    aside = _ref.aside;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_Train["default"], null),
    content: vendor
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], null),
    content: reservationCode
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], null),
    content: phoneNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Place["default"], null),
    content: address,
    multi: true
  }];
  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    from: {
      label: t('sifts.modals.cruise.departs'),
      text: departure.date,
      subText: departure.time
    },
    to: !(0, _isNil["default"])(returns) ? {
      label: t('sifts.modals.cruise.returns'),
      text: returns.date,
      subText: returns.time
    } : undefined
  }), items.map(function (_ref2, index) {
    var icon = _ref2.icon,
      content = _ref2.content,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: index,
      icon: icon,
      valign: rest.multi ? 'top' : undefined
    }, content);
  }));
};
var _default = exports["default"] = CruiseModal;
//# sourceMappingURL=Cruise.js.map